import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { WindowService } from 'src/shared/providers/window.service';

import { BookJob } from 'src/providers/book-job/book-job';
import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';
import { Client } from 'src/providers/client/client';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { EnableAutomaticBookingOnboarding } from '../enable-automatic-booking-onboarding/enable-automatic-booking-onboarding';
import { BookService } from 'src/shared/services/book.service';

@Component({
    selector: 'schedule-onboarding',
    templateUrl: './schedule.component.html',
    standalone: false
})
export class ScheduleOnboardingComponent {

  form: UntypedFormGroup;
  submitted = false;
  scheduleOptions = [
    { viewValue: 'Manually', value: 'manually' },
    { viewValue: 'Automatically', value: 'automatically' },
  ];

  
  boundSubmit = this.submit.bind(this);

constructor(
    private bookJobService: BookJob,
    private fb: UntypedFormBuilder,
    private onboardingProvider: OnboardingProvider,
    private storage: TidyStorage,
    private rightSidePanelService: RightSidePanelService,
    private navCtrl: CustomNavController,
    private client: Client,
    public windowService: WindowService,
    private bookService: BookService
  ) {
    this.form = this.fb.group({
      option: ['', Validators.required]
    });
  }

  async submit() {
    this.submitted = true;
    if (!this.form.valid) {
      return;
    }
    if (this.form.value.option === 'manually') {
      await this.goToBookJob();
    } else {
      this.rightSidePanelService.setDialogPageTitle('Auto-Schedule');
      this.rightSidePanelService.navigateTo('onboarding/enableAutomaticBooking', {}, EnableAutomaticBookingOnboarding);
    }
  }
  
  async goToBookJob() {
    this.bookJobService.clearBookJobStorage();
    this.storage.save('bookJobBackPage', 'schedule');
    const addresses = await this.client.getMoreDetailAddresses();
    const address = addresses[0];
    const params = {
      address,
      bookingType: 'add_job',
    };
    await this.bookService.goToBookJob(params);
  }

} 